import { Button, Checkbox, Col, Collapse, DatePicker, Divider, Form, Input, InputNumber, Radio, Row, Select, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { AgendaModel } from "../../../../models/agenda/agendaModel";
import dayjs from "dayjs";
import { atualizarAgenda, buscarAgenda, cadastrarAgenda } from "../../../../services/agendaService";
import { setModalCadastrarAgendaCompromissoFiscal } from "../../../../redux/slices/agendaCompromissoFiscal/agendaCompromissoFiscalSlice";

const { Option } = Select;
const { Panel } = Collapse;

const CadastroCompromissoFiscal = () => {
  //estados globais
  const agendaCompromissoFiscalState = useAppSelector((state) => state.agendaCompromissoFiscal);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<AgendaModel>();
  const [usaRecorrenciaIsChecked, setIsChecked] = useState(agendaCompromissoFiscalState.entity?.ativaRecorrencia);
  const [lembrar, setLembrar] = useState(true);
  const [dia, setDia] = useState(true);

  const editar = Object.values(agendaCompromissoFiscalState.entity).length !== 0;

  const inputInicial = useRef<any>(null);
  const recorrenciaValue = Form.useWatch("padraoRecorrencia", form);

  useEffect(() => {
    form.setFieldValue("idUsuarioAutor", persistedState.user.id);
    form.setFieldValue("dataCriacao", dayjs(new Date()));
    form.setFieldValue("padraoRecorrencia", "s");
    form.setFieldValue("ativaRecorrencia", usaRecorrenciaIsChecked);
    if (editar) {
      setIsChecked(agendaCompromissoFiscalState.entity?.ativaRecorrencia);
      form.setFieldsValue({
        ...agendaCompromissoFiscalState.entity,
      });
      form.setFieldValue("dataCompromisso", dayjs(new Date(agendaCompromissoFiscalState.entity.dataCompromisso)));
      form.setFieldValue("dataFimRecorrencia", dayjs(new Date(agendaCompromissoFiscalState.entity.dataFimRecorrencia)));
      form.setFieldValue("dataCriacao", dayjs(new Date(agendaCompromissoFiscalState.entity.dataCriacao)));
      form.setFieldValue("idUsuarioAutor", agendaCompromissoFiscalState.entity.idUsuarioAutor);
      form.setFieldValue("ativaRecorrencia", agendaCompromissoFiscalState.entity.ativaRecorrencia);
    }
  }, [agendaCompromissoFiscalState.entity]);

  const submit = async (value: any) => {
    if (editar) {
      const updateAgenda = { id: agendaCompromissoFiscalState.entity.id, dataInicioRecorrencia: value.dataCompromisso, ...value };
      dispatch(atualizarAgenda({ value: updateAgenda, busca: agendaCompromissoFiscalState.busca }));
    } else {
      value["dataInicioRecorrencia"] = value.dataCompromisso;
      const cadastroAgenda: AgendaModel = { ...value };
      dispatch(cadastrarAgenda({ value: cadastroAgenda, busca: agendaCompromissoFiscalState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarAgendaCompromissoFiscal(false));
  };

  const handleUsaRecorrenciaChange = (e: any) => {
    setIsChecked(e.target.checked);
  };

  const handleDiaChange = (value: any) => {
    if (value !== null) {
      setDia(false);
    } else {
      setDia(true);
    }
  };

  const handleLembrarChange = (value: any) => {
    if (value.target.checked) {
      setLembrar(false);
    } else {
      setLembrar(true);
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="Título"
            name="descricao"
            rules={[
              {
                required: true,
                message: "Digite um título",
              },
            ]}
          >
            <Input type="text" ref={inputInicial} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Autor" name="idUsuarioAutor">
            <Select defaultValue={persistedState.user.id} disabled={true} showArrow={false}>
              <Option value={persistedState.user.id}>{persistedState.user.nome}</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Data da criação" name="dataCriacao">
            <DatePicker disabled={true} format={"DD/MM/YYYY"} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 0]}>
        <Col span={6}>
          <Form.Item
            label="Data do Compromisso"
            name="dataCompromisso"
            rules={[
              {
                required: true,
                message: "Selecione a data do compromisso",
              },
            ]}
          >
            <DatePicker format={"DD/MM/YYYY"} />
          </Form.Item>
        </Col>
        {dia ? (
          <>
            {" "}
            <Col span={6}>
              <Form.Item label=" " name="avisoNoDia" valuePropName="checked">
                <Checkbox onChange={handleLembrarChange}>Lembrar no dia</Checkbox>
              </Form.Item>
            </Col>
          </>
        ) : (
          <></>
        )}
        {lembrar ? (
          <>
            {" "}
            <Col span={12}>
              <Form.Item label=" ">
                <Input.Group compact>
                  <Form.Item name={["textLembrar"]} style={{ marginRight: "10px" }}>
                    <span style={{ fontFamily: "'Inter'" }}>Lembrar com</span>
                  </Form.Item>
                  <Form.Item name={["numeroDiaAviso"]}>
                    <InputNumber min={1} max={7} controls={false} onChange={handleDiaChange} />
                  </Form.Item>
                  <Form.Item name={["textLembrar"]} style={{ marginLeft: "10px" }}>
                    <span style={{ fontFamily: "'Inter'" }}>dias de antecedência</span>
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
          </>
        ) : (
          <></>
        )}
      </Row>
      <Form.Item label="Assunto" name="assunto">
        <TextArea rows={3} />
      </Form.Item>
      <Form.Item label="" name="ativaRecorrencia" valuePropName="checked">
        <Checkbox onChange={handleUsaRecorrenciaChange}>Ativar recorrência para o compromisso</Checkbox>
      </Form.Item>
      <Collapse activeKey={usaRecorrenciaIsChecked ? ["1"] : []}>
        <Panel header="Compromisso recorrente" key="1">
          <Row gutter={[16, 0]}>
            <Col span={10}>
              <Form.Item label="Padrão de recorrência" name="padraoRecorrencia">
                <Radio.Group buttonStyle="solid">
                  {/* <Radio.Button value="d">Diário</Radio.Button> */}
                  <Radio.Button value="s">Semanal</Radio.Button>
                  <Radio.Button value="m">Mensal</Radio.Button>
                  <Radio.Button value="a">Anual</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Começa em:" name={"dataCompromisso"}>
                <DatePicker disabled={true} format={"DD/MM/YYYY"} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Termina em:"
                name="dataFimRecorrencia"
                rules={[
                  {
                    required: true,
                    message: "Selecione uma data fim",
                  },
                ]}
              >
                <DatePicker format={"DD/MM/YYYY"} />
              </Form.Item>
            </Col>
          </Row>
          {recorrenciaValue === "s" ? (
            <Row>
              <Form.Item name="recorrenciaSegunda" valuePropName="checked">
                <Checkbox>Segunda</Checkbox>
              </Form.Item>
              <Form.Item name="recorrenciaTerca" valuePropName="checked">
                <Checkbox>Terça</Checkbox>
              </Form.Item>
              <Form.Item name="recorrenciaQuarta" valuePropName="checked">
                <Checkbox>Quarta</Checkbox>
              </Form.Item>
              <Form.Item name="recorrenciaQuinta" valuePropName="checked">
                <Checkbox>Quinta</Checkbox>
              </Form.Item>
              <Form.Item name="recorrenciaSexta" valuePropName="checked">
                <Checkbox>Sexta</Checkbox>
              </Form.Item>
              <Form.Item name="recorrenciaSabado" valuePropName="checked">
                <Checkbox>Sabádo</Checkbox>
              </Form.Item>
              <Form.Item name="recorrenciaDomingo" valuePropName="checked">
                <Checkbox>Domingo</Checkbox>
              </Form.Item>
            </Row>
          ) : (
            <Row>
              <p style={{ color: "red", fontSize: "12px" }}>Nota: O evento ocorrerá {recorrenciaValue === "m" ? "mensalmente no dia" : "anualmente no dia e mês"} informado na data de compromisso</p>
            </Row>
          )}
        </Panel>
      </Collapse>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroCompromissoFiscal;
